import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const Block = styled.div<{
  $width: number;
  $height: number;
  $borderRadius: number;
}>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  flex-shrink: 0;
  background: linear-gradient(90deg, #f4f4f6 25%, #e7e8ec 50%, #f4f4f6 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;
